import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影", end: false },
  { to: "/category/tv", label: "电视剧", end: false },
  { to: "/category/variety", label: "综艺", end: false },
  { to: "/news", label: "影视资讯", end: false },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur-md border-b border-background-200/70">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px] gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0" onClick={() => setMenuOpen(false)}>
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950">
              <i className="ri-sun-line text-xl"></i>
            </span>
            <span className="font-heading font-extrabold text-lg md:text-xl tracking-tight text-foreground-950">
              向日葵视频
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={handleSubmit} className="hidden lg:flex items-center gap-2 flex-1 max-w-xs ml-auto">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集或资讯"
                className="w-full h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-md bg-secondary-800 text-background-50 text-sm font-medium hover:bg-secondary-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md bg-background-100 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            <form onSubmit={handleSubmit} className="flex items-center gap-2">
              <div className="relative flex-1">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影片、剧集或资讯"
                  className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm outline-none focus:border-primary-400"
                />
              </div>
              <button
                type="submit"
                className="h-11 px-4 rounded-md bg-secondary-800 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-100 text-foreground-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}